import { apiFetch } from 'utils/apiFetch'
import type { TIcsDashboardData } from '../types'

export const fetchNdviData = async (blockIds: number[]): Promise<TIcsDashboardData['ndvi']> => {
  const response = await apiFetch({
    url: '/values-current',
    body: {
      blocks: {
        blockIds,
        values: {
          imageryOverlayNDVI_current: true,
          imageryOverlayNDVIChange_sinceLastImage: true,
          imageryOverlayNDVIChange_sinceLastMonth: true,
        },
      },
    },
    params: { timeout: 60 * 1000 },
  })

  const blocks = response?.blocks ?? {}

  return blockIds.flatMap((blockId) => {
    const block = blocks[blockId]
    const current = block?.imageryOverlayNDVI_current?.value
    const sinceLastImage = block?.imageryOverlayNDVIChange_sinceLastImage?.value
    const sinceLastMonth = block?.imageryOverlayNDVIChange_sinceLastMonth?.value

    if (!current) return []

    return {
      block_id: blockId,
      current_image: {
        uniformity: current.uniformity,
        image_date: current.image_date,
        ndvi_mean: current.ndvi_mean,
        src: current.src,
      },
      since_last_image: sinceLastImage
        ? {
            uniformity: sinceLastImage.uniformity,
            ndvi_mean: sinceLastImage.ndvi_mean,
            image_date: sinceLastImage.image_date,
            previous_image_date: sinceLastImage.previous_image_date ?? '',
            src: sinceLastImage.src,
            ndvi_mean_change: sinceLastImage.ndvi_mean_change ?? 0,
            uniformity_change: sinceLastImage.uniformity_change ?? 0,
          }
        : null,
      since_last_month: sinceLastMonth
        ? {
            uniformity: sinceLastMonth.uniformity,
            ndvi_mean: sinceLastMonth.ndvi_mean,
            image_date: sinceLastMonth.image_date,
            previous_image_date: sinceLastMonth.previous_image_date ?? null,
            src: sinceLastMonth.src ?? null,
            ndvi_mean_change: sinceLastMonth.ndvi_mean_change ?? null,
            uniformity_change: sinceLastMonth.uniformity_change ?? null,
          }
        : null,
    }
  })
}
